<template>
  <Layout :page="'Thêm mới sản phẩm'" @submit="submit = $event">
    <div v-if="dataPermission && dataPermission.includes('NSH_ITEM_PROD_CREATE')">
      <ValidationObserver ref="observerItems">
        <b-form @submit.stop.prevent="">
          <LayoutCard>
            <LayoutCardTitle>Thông tin cơ bản </LayoutCardTitle>
            
            <LayoutFieldSet>
              <LayoutField :required="true">
                <template #label>Tên sản phẩm</template>
                <template #input>
                  <BaseInput
                    :placeholder="'Nhập tên sản phẩm'"
                    v-model="Item.name"
                    :name="'Tên sản phẩm'"
                    :rules="'required|lBetween:3,255|CHECK_HTML'"
                    @blur="setNameVariation($event)"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField>
                <template #label> Đơn vị tính</template>
                <template #input>
                  <BaseSelect
                    :options="dataUnit"
                    :label="'unitName'"
                    :placeholder="'Chọn đơn vị tính'"
                    v-model="Item.unit.name"
                    @select="getValueUnit($event)"
                    :showADD="true"
                  >
                    <template #showADD>
                      <div 
                        @click="isPopupAddUnit = true" 
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm đơn vị tính
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>
              <LayoutField>
                <template #label>Khối lượng</template>
                <template #input>
                  <BaseInput
                    :unit="'gr'"
                    v-model="Item.weightInGram"
                    :type="'unit'"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField v-if="!showNote">
                <template #input>
                  <div class="box-dashed" @click="showNote = true">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.5833 9.16667H10.8333V5.41667C10.8333 5.20833 10.625 5 10.4167 5H9.58333C9.34896 5 9.16667 5.20833 9.16667 5.41667V9.16667H5.41667C5.18229 9.16667 5 9.375 5 9.58333V10.4167C5 10.651 5.18229 10.8333 5.41667 10.8333H9.16667V14.5833C9.16667 14.8177 9.34896 15 9.58333 15H10.4167C10.625 15 10.8333 14.8177 10.8333 14.5833V10.8333H14.5833C14.7917 10.8333 15 10.651 15 10.4167V9.58333C15 9.375 14.7917 9.16667 14.5833 9.16667Z"
                      />
                    </svg>
                    <span>Thêm mô tả sản phẩm</span>
                  </div>
                </template>
              </LayoutField>

              <LayoutField v-else>
                <template #label>Mô tả</template>
                <template #input>
                  <BaseTextarea
                    :value="Item.description"
                    @value="Item.description = $event"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <!-- <LayoutFieldSet>
              <LayoutField :fixWidth="true">
                <template #label>Đang bán</template>
                <template #input>
                  <div class="isSelling">
                    <BaseSwitcher v-model="Item.metaSearchable.isSelling" />
                    <div style="color: #3e69f6">
                      {{
                        Item.metaSearchable.isSelling ? "Hiển thị" : "Ngưng bán"
                      }}
                    </div>
                  </div>
                </template>
              </LayoutField>
            </LayoutFieldSet> -->
          </LayoutCard>

          <LayoutCard>
            <LayoutCardTitle>Phân loại</LayoutCardTitle>

            <LayoutFieldSet>
              <LayoutField >
                <template #label>Danh mục</template>
                <template #input>
                  <BaseSelect
                    :options="dataCategory"
                    label="name"
                    placeholder="Chọn danh mục"
                    v-model="Item.metaSearchable.category"
                    @select="getListCategorySub($event)"
                    :hideRemove="true"
                    :showADD="true"
                  >
                    <template #showADD>
                      <div 
                        @click="isPopupAddCategory = true" 
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm nhanh danh mục
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>
              <LayoutField >
                <template #label>Loại sản phẩm</template>
                <template #input>
                  <BaseSelect
                    v-model="Item.categorySub"
                    :options="dataCategorySub"
                    :label="'name'"
                    placeholder="Chọn loại sản phẩm"
                    @select="getValueCategorySub($event)"
                    :hideRemove="true"
                    :showADD="(Item.metaSearchable.category !== '') ? true : false"
                  >
                    <template #showADD>
                      <div 
                        @click="isPopupAddCategorySub = true" 
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm nhanh loại sản phẩm
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField>
                <template #label>Thương hiệu</template>
                <template #input>
                  <BaseSelect
                    :options="dataBrands"
                    :label="'brandName'"
                    placeholder="Chọn thương hiệu"
                    v-model="Item.metaSearchable.brand"
                    @select="Item.metaSearchable.brand = $event.text"
                    :showADD="true"
                  >
                    <template #showADD>
                      <div 
                        @click="isPopupAddBrand = true" 
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm thương hiệu
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>

              <LayoutField>
                <template #label>Bảo hành</template>
                <template #input>
                  <BaseSelect
                    v-model="Item.warranty.warrantyName"
                    :options="dataWarranty"
                    :label="'warrantyName'"
                    placeholder="Chọn bảo hành"
                    @select="getValueWarranty($event, null)"
                    :showADD="true"
                  >
                    <template #showADD>
                      <div 
                        @click="isPopupAddWarranty = true" 
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm bảo hành
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField style="flex: 0 0 100%;">
                <template #label>Hình thức quản lý</template>
                <template #input>
                  <div class="field_check_box">
                    <div class="check_box">
                      <BaseCheckbox
                        type="radio"
                        v-model="Item.metaSearchable.statusDefault"
                        @click="changeStatus(Item.metaSearchable.statusDefault, 'default' )"
                      />
                      <div style="color: #3e69f6">Sản phẩm thường</div>
                    </div>

                    <div class="check_box" v-if="activeImeiByMerchant">
                      <BaseCheckbox
                        type="radio"
                        v-model="Item.metaSearchable.statusImei"
                        :disabled="!activeImeiByMerchant"
                        @click="changeStatus(Item.metaSearchable.statusImei, 'imei')"
                      />
                      <div style="color: #3e69f6">Sản phẩm IMEI/Serial</div>
                    </div>
                    <div class="check_box" v-if="useProductBatch">
                      <BaseCheckbox
                        type="radio"
                        v-model="Item.metaSearchable.statusBatch"
                        :disabled="!useProductBatch"
                        @click="changeStatus(Item.metaSearchable.statusBatch, 'batch')"
                      />
                      <div style="color: #3e69f6">Sản phẩm có HSD</div>
                    </div>
                  </div>
                </template>
              </LayoutField>
            </LayoutFieldSet>
          </LayoutCard>

          <LayoutCard>
            <LayoutCardTitle>Hình ảnh</LayoutCardTitle>

            <LayoutFieldSet>
              <LayoutField>
                <template #label>Hình ảnh đại diện</template>
                <template #input>
                  <BaseUploadImage
                    :value="avatar.images"
                    type="avatar"
                    @value="avatar.images = $event"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField>
                <template #label>Hình ảnh sản phẩm</template>
                <template #input>
                  <BaseUploadImage
                    :value="listImages"
                    @value="listImages = $event"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>
          </LayoutCard>

          <LayoutCard>
            <LayoutCardTitle>Thuộc tính </LayoutCardTitle>

            <LayoutCardNote>
              <b>Tên thuộc tính</b> có thể là Kích thước, Màu sắc, Chất liệu…
              <br />
              <b>Giá trị của thuộc tính</b> có thể là S - M - L (Kích thước),
              Xanh - Đỏ - Hồng (Màu sắc), Vải Cotton - Da lộn - Lụa (Chất liệu).
            </LayoutCardNote>

            <b-table
              head-variant="light"
              tbody-tr-class="row-table-class"
              hover
              :items="optionsItem"
              :fields="fieldProperty"
              v-if="showTableVariations"
            >
              <template #cell(name)="data">
                {{ data.item.name }}
              </template>

              <template #cell(values)="data">
                {{ data.item.values.join(", ") }}
              </template>
            </b-table>

            <LayoutControl>
              <BaseButton
                variant="outline-dashed"
                type="button"
                @click="showPopup('them-thuoc-tinh')"
              >
                <template #icon-before>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.5833 9.16667H10.8333V5.41667C10.8333 5.20833 10.625 5 10.4167 5H9.58333C9.34896 5 9.16667 5.20833 9.16667 5.41667V9.16667H5.41667C5.18229 9.16667 5 9.375 5 9.58333V10.4167C5 10.651 5.18229 10.8333 5.41667 10.8333H9.16667V14.5833C9.16667 14.8177 9.34896 15 9.58333 15H10.4167C10.625 15 10.8333 14.8177 10.8333 14.5833V10.8333H14.5833C14.7917 10.8333 15 10.651 15 10.4167V9.58333C15 9.375 14.7917 9.16667 14.5833 9.16667Z"
                    />
                  </svg>
                </template>
                Thêm thuộc tính
              </BaseButton>
            </LayoutControl>
          </LayoutCard>

          <LayoutCard>
            <LayoutCardTitle>Thiết lập phiên bản</LayoutCardTitle>

            <LayoutCardNote>
              <b>Phiên bản sản phẩm</b> được tạo ra từ các tuỳ chọn thuộc tính
            </LayoutCardNote>

            <el-dropdown 
              v-if="selectedBox.length > 0"
              trigger="click"
              placement="bottom-start"
            >
              <el-button type="secondary">
                Thao tác nhanh
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span type="button" @click="checkBarcode()">Tạo mã vạch tự động</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span type="button" @click="$router.push({ path: '/barcode/choose' })">In mã vạch</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span class="text-danger" @select="selectOptionQuick($event)">Xoá phiên bản</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <LayoutControl v-if="selectedBox.length > 0">
              <div style="flex: 1 1 auto">
                <BaseInput
                  v-model="exportPrice"
                  :type="'money'"
                  placeholder="Giá bán"
                />
              </div>
              <div style="flex: 1 1 auto">
                <BaseInput
                  v-model="importPrice"
                  :type="'money'"
                  placeholder="Giá nhập"
                />
              </div>
              <div style="flex: 0 0 auto">
                <BaseButton type="button" @click="inputPriceForRecords">
                  Áp dụng cho tất cả
                </BaseButton>
              </div>
            </LayoutControl>

            <div style="overflow-x: auto; max-width: 100%; width: 100%">
              <b-table
                :items="variationOnly"
                :fields="fieldVariationOnly.filter(e => e.show)"
                v-if="!showTableVariations"
              >
                <template #head(edit)>
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="cursor: pointer"
                    @click="showPopup('Cai-dat-hien-thi')"
                  >
                    <path
                      d="M6.16016 9.50391C6.85449 9.50391 7.4082 8.9502 7.4082 8.25586C7.4082 7.57031 6.85449 7.00781 6.16016 7.00781C5.47461 7.00781 4.91211 7.57031 4.91211 8.25586C4.91211 8.9502 5.47461 9.50391 6.16016 9.50391ZM10.291 9.09961H22.2266C22.7012 9.09961 23.0791 8.73047 23.0791 8.25586C23.0791 7.78125 22.71 7.41211 22.2266 7.41211H10.291C9.8252 7.41211 9.44727 7.78125 9.44727 8.25586C9.44727 8.73047 9.81641 9.09961 10.291 9.09961ZM6.16016 14.9092C6.85449 14.9092 7.4082 14.3555 7.4082 13.6611C7.4082 12.9756 6.85449 12.4131 6.16016 12.4131C5.47461 12.4131 4.91211 12.9756 4.91211 13.6611C4.91211 14.3555 5.47461 14.9092 6.16016 14.9092ZM10.291 14.5049H22.2266C22.7012 14.5049 23.0791 14.1357 23.0791 13.6611C23.0791 13.1865 22.71 12.8174 22.2266 12.8174H10.291C9.8252 12.8174 9.44727 13.1865 9.44727 13.6611C9.44727 14.1357 9.81641 14.5049 10.291 14.5049ZM6.16016 20.3145C6.85449 20.3145 7.4082 19.7607 7.4082 19.0664C7.4082 18.3809 6.85449 17.8184 6.16016 17.8184C5.47461 17.8184 4.91211 18.3809 4.91211 19.0664C4.91211 19.7607 5.47461 20.3145 6.16016 20.3145ZM10.291 19.9102H22.2266C22.7012 19.9102 23.0791 19.541 23.0791 19.0664C23.0791 18.5918 22.71 18.2227 22.2266 18.2227H10.291C9.8252 18.2227 9.44727 18.5918 9.44727 19.0664C9.44727 19.541 9.81641 19.9102 10.291 19.9102Z"
                      fill="#888888"
                    />
                  </svg>
                </template>

                <template #cell(edit)>
                  <!-- <IconEditRecord
                    :options="optionsEdit"
                    @select="
                      showPopup(`chinh-sua-phien-ban-${Item.priceItem.name}`)
                    "
                  />
                  <ItemEditVariation
                    :data="Item.priceItem"
                    @value="Item.priceItem = $event"
                  /> -->
                </template>

                <template #cell(name)>
                  {{ Item.name === "" ? "Mặc định" : Item.name }}
                </template>

                <template #cell(sku)>
                  <BaseInput 
                    :placeholder="'Nhập SKU'"
                    v-model="Item.sku"
                    type="SKU_UPC"
                    :rules="'SKU|lBetween:1,16'"
                    :validate="Item.validate.sku"
                    @blur="checkSKU(Item.sku)"
                  />
                </template>

                <template #cell(upc)>
                  <BaseInput class="upc-input"
                    :placeholder="'Nhập Barcode/UPC'"
                    v-model="Item.upc"
                    name="Barcode"
                    type="SKU_UPC"
                    :rules="'BARCODE|lBetween:5,13'"
                    :validate="Item.validate.upc"
                    :btn="true"
                    @blur="checkUPC(Item.upc)"
                  >
                    <template #btn-input v-if="Item.upc == ''">
                      <span class="text-primary" @click="generateBarcode()">Tạo</span>
                    </template>
                  </BaseInput>
                </template>

                <template #cell(importPrice)>
                  <BaseInput
                    v-model="Item.priceItem.importPrice"
                    type="money"
                  />
                </template>

                <template #cell(exportPrice)>
                  <BaseInput
                    v-model="Item.priceItem.exportPrice"
                    type="money"
                  />
                </template>
              </b-table>
            </div>

            <div style="overflow-x: auto; max-width: 100%; width: 100%">
              <b-table
                :items="Item.variations"
                :fields="fieldsVariation.filter(e => e.show)"
                v-if="showTableVariations"
              >
                <template #head(edit)>
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="cursor: pointer"
                    @click="showPopup('Cai-dat-hien-thi')"
                  >
                    <path
                      d="M6.16016 9.50391C6.85449 9.50391 7.4082 8.9502 7.4082 8.25586C7.4082 7.57031 6.85449 7.00781 6.16016 7.00781C5.47461 7.00781 4.91211 7.57031 4.91211 8.25586C4.91211 8.9502 5.47461 9.50391 6.16016 9.50391ZM10.291 9.09961H22.2266C22.7012 9.09961 23.0791 8.73047 23.0791 8.25586C23.0791 7.78125 22.71 7.41211 22.2266 7.41211H10.291C9.8252 7.41211 9.44727 7.78125 9.44727 8.25586C9.44727 8.73047 9.81641 9.09961 10.291 9.09961ZM6.16016 14.9092C6.85449 14.9092 7.4082 14.3555 7.4082 13.6611C7.4082 12.9756 6.85449 12.4131 6.16016 12.4131C5.47461 12.4131 4.91211 12.9756 4.91211 13.6611C4.91211 14.3555 5.47461 14.9092 6.16016 14.9092ZM10.291 14.5049H22.2266C22.7012 14.5049 23.0791 14.1357 23.0791 13.6611C23.0791 13.1865 22.71 12.8174 22.2266 12.8174H10.291C9.8252 12.8174 9.44727 13.1865 9.44727 13.6611C9.44727 14.1357 9.81641 14.5049 10.291 14.5049ZM6.16016 20.3145C6.85449 20.3145 7.4082 19.7607 7.4082 19.0664C7.4082 18.3809 6.85449 17.8184 6.16016 17.8184C5.47461 17.8184 4.91211 18.3809 4.91211 19.0664C4.91211 19.7607 5.47461 20.3145 6.16016 20.3145ZM10.291 19.9102H22.2266C22.7012 19.9102 23.0791 19.541 23.0791 19.0664C23.0791 18.5918 22.71 18.2227 22.2266 18.2227H10.291C9.8252 18.2227 9.44727 18.5918 9.44727 19.0664C9.44727 19.541 9.81641 19.9102 10.291 19.9102Z"
                      fill="#888888"
                    />
                  </svg>
                </template>

                <template #head(selected)>
                  <BaseCheckbox v-model="selectAll" />
                </template>

                <template #cell(edit)>
                  <!-- <IconEditRecord
                    :options="optionsEdit"
                    @select="
                      showPopup(`chinh-sua-phien-ban-${Item.priceItem.name}`)
                    "
                  />
                  <ItemEditVariation
                    :data="Item.priceItem"
                    @value="Item.priceItem = $event"
                  /> -->
                </template>

                <template #cell(selected)="data">
                  <BaseCheckbox v-model="selectedBox" :value="data.item" />
                </template>

                <template #cell(images)="data">
                  <ItemSelectImage
                    :value="data.item"
                    :list="listImages"
                    @value="data.item.images = $event"
                  />
                </template>

                <template #cell(name)="data">
                  <BaseInput
                    :placeholder="'Nhập tên hiển thị'"
                    v-model="data.item.name"
                  />
                </template>

                <template #cell(sku)="data">
                  <BaseInput
                    placeholder="Nhập SKU"
                    v-model="data.item.sku"
                    type="SKU_UPC"
                    :rules="'SKU|lBetween:1,16'"
                    :validate="data.item.validate.sku"
                    @blur="checkSKU(data.item.sku, data.index)"
                  />
                </template>

                <template #cell(upc)="data">
                  <BaseInput class="upc-input"
                    placeholder="Nhập Barcode/UPC"
                    v-model="data.item.upc"
                    type="SKU_UPC"
                    :rules="'BARCODE|lBetween:5,13'"
                    :validate="data.item.validate.upc"
                    :btn="true"
                    @blur="checkUPC(data.item.upc, data.index)"
                  >
                    <template #btn-input v-if="data.item.upc == ''">
                      <span class="text-primary" @click="generateBarcode(data.index)">Tạo</span>
                    </template>
                  </BaseInput>
                </template>

                <template #cell(importPrice)="data">
                  <BaseInput
                    v-model="data.item.prices.importPrice"
                    type="money"
                  />
                </template>

                <template #cell(exportPrice)="data">
                  <BaseInput
                    v-model="data.item.prices.exportPrice"
                    type="money"
                  />
                </template>
              </b-table>
            </div>
          </LayoutCard>
        </b-form>
      </ValidationObserver>

      <ItemOption :options="optionsItem" @options="handleVariation($event)" />

      <ItemArrangeColumn
        v-model="listFields"
        @value="
          showTableVariations
            ? (fieldsVariation = $event)
            : (fieldVariationOnly = $event)
        "
      />

      <LayoutPopup id="Dieu-chinh-ton-kho" size="small">
        <template #title>Tạo sản phẩm thành công</template>
        <template #content>
          Các phiên bản sản phẩm có số lượng tồn kho khởi tạo là 0. Bạn có muốn
          cập nhật tồn kho cho sản phẩm này không?
        </template>
        <template #control-right>
          <BaseButton
            size="sm"
            variant="secondary"
            @click="$router.push(`/items`)"
          >
            Không
          </BaseButton>
          <BaseButton
            size="sm"
            @click="popupEnableInventory = true"
            v-if="check"
          >
            Cập nhật tồn kho
          </BaseButton>
          <BaseButton
            size="sm"
            @click="checkInInventory()"
            v-else
          >
            Cập nhật tồn kho
          </BaseButton>

        </template>
      </LayoutPopup>
    </div>
    <NotPermission v-else></NotPermission>

    <div class="box-loading" v-if="loading">
      <div class="loading">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
      </div>
    </div>

    <PopupCheckBarcode 
      :existedUpc="existedUpc"
      :selectedBox="selectedBox"
      @getValue="inputUpcForRecords($event)"
      type="variations"
    />

    <PopupAddUnit
      :isPopup="isPopupAddUnit" 
      @getValue="getValueUnit($event, 'add-new')" 
    />

    <PopupAddBrand
      :isPopup="isPopupAddBrand" 
      @getValue="getValueBrand($event)" 
    />

    <PopupAddWarranty
      :isPopup="isPopupAddWarranty" 
      @getValue="getValueWarranty($event, 'add-new')" 
    />

    <PopupAddCategory
      :isPopup="isPopupAddCategory" 
      @getValue="getListCategorySub($event, 'add-new')" 
    />

    <PopupAddCategorySub
      :isPopup="isPopupAddCategorySub" 
      :category="categoryTmp"
      :listCategory="dataCategory"
      @getValue="getValueCategorySub($event, 'add-new')" 
    />

    <b-modal
        v-model="popupEnableInventory"
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        centered
        title="Cập nhật tính năng kho"
        id="bv-modal-enable-inventory">
        <div class="box-modals">
          <div class="text-head-modal text-bold">Quản lý kho và Tồn kho</div>
          <div class="mt-3 text-center">
          <img src="/assets/warehousew.png" width="100">
          </div>
          <div class="text-head-active mt-1">Cửa hàng của bạn chưa kích hoạt tính năng <b>Quản lý kho</b> và <b>Tồn kho</b></div>
          <div class="text-des-active mt-3">Bên cạnh việc quản lý các hoạt động bán hàng, quản lý kho là một chức năng quan trọng. NextShop hỗ trợ kiểm soát hàng tồn kho nhanh chóng, nghiệp vụ xuất/nhập/chuyển kho chính xác, giảm thiểu tỉ lệ thất thoát đến 30%.</div>
          <div class="mt-3 line-active text-right">
          <span class="text-primary cursor btn-closed" @click="(popupEnableInventory=false, activeTab=0)">Đóng</span>
          <b-button variant="primary" size="md" class="btn btn-md btn-primary" v-if="isUpload"><i class="fas fa-spinner fa-spin"></i> Đang xử lý</b-button>
          <span class="btn btn-md btn-primary" v-if="!isUpload" @click="clickEnableInventory">Kích hoạt ngay</span>
          </div>
        </div>
    </b-modal>
		<b-modal
			v-model="popupEnableInventorySuccess"
			hide-header
			hide-footer
			no-close-on-backdrop
			centered
			title="Cập nhật tính năng kho"
			id="bv-modal-enable-inventory-success">
      <div class="box-modals">
        <div class="text-head-modal text-bold">Kích hoạt kho hàng thành công!</div>
        <div class="mt-3 text-center">
        <img src="/assets/store.png" width="100">
        </div>
        <div class="text-des-active mt-3">Từ giờ bạn đã có thể thêm sản phẩm bằng cách <b>Nhập kho, Kiểm hàng trong kho</b>, và nhiều tính năng khác!</div>
        <div class="mt-3 line-active text-right">
        <div class="ext-primary cursor btn-closed" @click="clickHideInventorySuccess">Đóng</div>
        </div>
      </div>
		</b-modal>
  </Layout>
</template>

<script>
import moment from "moment";
import Swal from "sweetalert2";

import Layout from "@/router/layouts/item";
import ItemOption from "@/pages/items/components/ItemOption.vue";
import ItemSelectImage from "@/pages/items/components/ItemSelectImage.vue";
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";
// import ItemEditVariation from "@/pages/items/components/ItemEditVariation.vue";
import PopupAddUnit from "@/components/popup-add-quick/popup-add-unit.vue";
import PopupAddBrand from "@/components/popup-add-quick/popup-add-brand.vue";
import PopupAddWarranty from "@/components/popup-add-quick/popup-add-warranty.vue"
import PopupAddCategory from "@/components/popup-add-quick/popup-add-category.vue"
import PopupAddCategorySub from "@/components/popup-add-quick/popup-add-categorysub.vue"

import PopupCheckBarcode from "@/pages/items/components/PopupCheckBarcode"

import dublicate from "@/mixins/items/checkDublicate";
import getListUnit from "@/mixins/items/getListUnit";
import getListBrand from "@/mixins/items/getListBrand";
import getListCategory from "@/mixins/items/getListCategory";
import getListWarranty from "@/mixins/items/getListWarranty";
import handlerReqCreatItem from "@/mixins/items/handlerReqCreatItem";
import genBarcode from "@/mixins/items/handleBarcode"

import { CategoryService } from "@/services/nextshop/category.service";
import { ProductService } from "@/services/nextshop/product.service";
import { SettingService } from "@/services/nextshop/setting.service"
export default {
  components: {
    Layout,
    ItemOption,
    ItemSelectImage,
    ItemArrangeColumn,
    // ItemEditVariation,
    PopupAddUnit,
    PopupAddBrand,
    PopupAddWarranty,
    PopupAddCategory,
    PopupAddCategorySub,
    PopupCheckBarcode
  },

  mixins: [
    dublicate,
    getListUnit,
    getListBrand,
    getListCategory,
    getListWarranty,
    handlerReqCreatItem,
    genBarcode,
  ],

  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      loading: false,
      showNote: false,
      submit: false,
      showTableVariations: false,
      submitAddProperty: false,
      disabledSubmit: false,
      activeStatusByMerchant: false,
      isPopupAddUnit: false,
      isPopupAddBrand: false,
      isPopupAddWarranty: false,
      isPopupAddCategory: false,
      isPopupAddCategorySub: false,
      importPrice: '',
      exportPrice: '',
      idItem: "",
      resItem: {},
      categoryTmp: {},
      selectedBox: [],
      fieldsVariation: [
        {
          label: "",
          key: "selected",
          thStyle: { width: "45px",
          'min-width': "45px" },
          show: true,
          disabled: true,
        },
        {
          label: "Hình ảnh",
          key: "images",
          thStyle: { width: "77px",
          'min-width': "77px" },
          show: true,
          disabled: false,
        },
        {
          label: "Tên phiên bản",
          key: "nameOption",
          thStyle: { width: "210px",
          'min-width': "210px" },
          show: true,
          disabled: true,
        },
        {
          label: "Tên hiển thị",
          key: "name",
          thStyle: { width: "210px",
          'min-width': "210px" },
          show: true,
          disabled: false,
        },
        {
          label: "Giá nhập",
          key: "importPrice",
          thStyle: { width: "160px",
          'min-width': "160px" },
          show: true,
          disabled: false,
        },
        {
          label: "Giá bán",
          key: "exportPrice",
          thStyle: { width: "160px",
          'min-width': "160px" },
          show: true,
          disabled: false,
        },
        {
          label: "SKU",
          key: "sku",
          thStyle: { width: "160px" ,
          'min-width': "160px" },
          show: true,
          disabled: true,
        },
        {
          label: "Barcode/UPC",
          key: "upc",
          thStyle: { width: "160px" ,
          'min-width': "160px"},
          show: true,
          disabled: false,
        },
        {
          label: "",
          key: "edit",
          thStyle: { width: "44px" ,
          'min-width': "44px"},
          show: true,
          disabled: false,
        },
      ],
      fieldVariationOnly: [
        {
          label: "Phiên bản",
          key: "name",
          thStyle: { width: "20%",
          'min-width': "100px" },
          show: true,
          disabled: true,
        },
        {
          label: "Giá nhập",
          key: "importPrice",
          thStyle: { width: "17.5%",
          'min-width': "120px" },
          show: true,
          disabled: false,
        },
        {
          label: "Giá bán",
          key: "exportPrice",
          thStyle: { width: "17.5%",
          'min-width': "120px" },
          show: true,
          disabled: false,
        },
        {
          label: "Barcode",
          key: "upc",
          thStyle: { width: "20%",
          'min-width': "100px" },
          show: true,
          disabled: false,
        },
        {
          label: "SKU",
          key: "sku",
          thStyle: { width: "20%",
          'min-width': "100px" },
          show: true,
          disabled: true,
        },
        {
          label: "",
          key: "edit",
          thStyle: { width: "5%",
          'min-width': "50px" },
          show: true,
          disabled: true,
        },
      ],
      fieldProperty: [
        {
          label: "Thuộc tính",
          key: "name",
          thStyle: { width: "30%" },
        },
        {
          label: "Giá trị",
          key: "values",
          thStyle: { width: "50%" },
        },
      ],
      dataUnit: [],
      dataBrands: [],
      dataWarranty: [],
      dataCategory: [],
      dataCategorySub: [],
      listFields: [],
      optionsQuick: [{ id: 0, text: "Xoá phiên bản" }],
      optionsEdit: [{ id: 0, text: "Chỉnh sửa" }],
      avatar: {
        nameOption: "Phien-ban-goc ",
        images: [],
      },
      listImages: [],
      optionsItem: [
        {
          name: "",
          values: [""],
        },
      ],
      variationOnly: [
        {
          name: "Mặc định",
          exportPrice: 0,
          importPrice: 0,
          sku: "",
          upc: "",
          unit: "",
        },
      ],
      Item: {
        name: "",
        weightInGram: 0,
        categoryId: "",
        categorySub: "",
        metaSearchable: {
          brand: "",
          isSelling: true,
          category: "",
          statusDefault: true,
          statusImei: false,
          statusBatch: false,
          useImeiAndSerial: "false",
          useProductBatch: "false"
        },
        description: "",
        images: [],
        options: [],
        sku: "",
        upc: "",
        validate: {
          sku: "",
          upc: "",
        },
        tags: [],
        unit: {
          name: "Cái",
        },
        variations: [],
        selected: false,
        priceItem: {
          name: "Mặc định",
          exportPrice: 0,
          importPrice: 0,
        },
        warranty: {
          description: "",
          dueAtInMinute: "3021-01-26T20:14:52.036Z",
          duration: 0,
          timeUnit: "",
          warrantyName: "",
        },
      },
      existedUpc: [],
      popupEnableInventory: false,
			popupEnableInventorySuccess: false,
			isUpload: false,
			coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
      check: false,
      useProductBatch: false,
      activeImeiByMerchant: false
    };
  },

  async created() {
    try {
      this.loading = true
      this.listFields = this.fieldVariationOnly;
      this.dataUnit = await this.getListUnit();
      this.dataCategory = await this.getListCategory();
      this.dataBrands = await this.getListBrand();
      this.dataWarranty = await this.getListWarranty();
      await this.checkConfigInventory()
      this.loading = false
    } catch (error) {
      console.log(error);
    }
  },

  computed: {
    selectAll: {
      get: function () {
        if (this.selectedBox.length === this.Item.variations.length) {
          return "TRUE";
        } else if (this.selectedBox.length === 0) {
          return "FALSE";
        } else {
          return "ORTHER";
        }
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.Item.variations.forEach(function (item) {
            selected.push({
              ...item
            });
          });
        }
        this.selectedBox = selected;
      },
    },
  },

  methods: {
    checkInInventory() {
      const query = {
        categoryId: this.resItem.item.categoryId,
        itemId: this.resItem.item.id,
        itemPriceId: this.resItem.itemPrice.id
      }
      if (this.Item.metaSearchable.statusImei || this.Item.metaSearchable.statusBatch) {
        // this.$router.push(`/storage-create/${this.idItem}`)
        this.$router.push({ 
          path: `/storage-create/${this.idItem}`,
          query,
        });
      } else {
        // this.$router.push(`/items/items-edit-inventory/${this.idItem}`)
        this.$router.push({ 
          path: `/items/items-edit-inventory/${this.idItem}`,
          query,
        });
      }
    },

    changeStatus(value, type) {
      if (type === "default" && value) {
        this.Item.metaSearchable.statusImei = !value
        this.Item.metaSearchable.statusBatch = !value
      } else if (type === 'batch' && value) {
        this.Item.metaSearchable.statusDefault = !value
        this.Item.metaSearchable.statusImei = !value
      } else if (type === 'imei' && value) {
        this.Item.metaSearchable.statusDefault = !value
        this.Item.metaSearchable.statusBatch = !value
      }else{
        this.Item.metaSearchable.statusDefault = true
        this.Item.metaSearchable.statusImei = false
        this.Item.metaSearchable.statusBatch = false
      }
      this.Item.metaSearchable.statusImei ? this.Item.metaSearchable.useImeiAndSerial = "true" : this.Item.metaSearchable.useImeiAndSerial = "false" 
      this.Item.metaSearchable.statusBatch ? this.Item.metaSearchable.useProductBatch = "true" : this.Item.metaSearchable.useProductBatch = "false" 
    },

    getValueCategorySub($event, type) {
      this.isPopupAddCategorySub = false
      if ($event != null) {
        if ($event.name != '') {
          this.Item.categoryId = $event.id;
          this.Item.categorySub = $event.name;
        }

        if (type === 'add-new') {
          this.dataCategorySub.unshift($event)
        }
      }
    },

    getValueUnit(data, type) {
      this.isPopupAddUnit = false
      if (data !== null) {
        if (data.unitName != '') {
          this.Item.unit.name = data.unitName
        }

        if (type == 'add-name') {
          this.dataUnit.unshift(data)
        }
      }
    },

    getValueBrand(data) {
      this.isPopupAddBrand = false
      if (data !== null) {
        if (data.brandName != '') {
          this.dataBrands.unshift(data),
          this.Item.metaSearchable.brand = data.brandName
        }
      }
    },

    getValueWarranty($event, type) {
      this.isPopupAddWarranty = false
      if ($event != null ) {
        if ($event.warrantyName != "") {
          let date =
            $event.unit === "NGAY"
              ? new Date(
                  moment().endOf("day").add($event.warrantyPeriod, "days")._d
                ).toISOString()
              : $event.unit === "THANG"
              ? new Date(
                  moment().endOf("month").add($event.warrantyPeriod, "months")._d
                ).toISOString()
              : new Date(
                  moment().endOf("years").add($event.warrantyPeriod, "years")._d
                ).toISOString();
  
          this.Item.warranty.duration = $event.warrantyPeriod;
          this.Item.warranty.timeUnit = $event.unit;
          this.Item.warranty.description = $event.warrantyName;
          this.Item.warranty.warrantyName = $event.warrantyName;
          this.Item.warranty.dueAtInMinute = date;
        }
        if (type == 'add-new') {
          this.dataWarranty.unshift($event)
        }
      } else if ($event == null) {
        return
      } else {
        this.Item.warranty = {
          description: "",
          dueAtInMinute: "3021-01-26T20:14:52.036Z",
          duration: 0,
          timeUnit: "",
          warrantyName: "",
        };
      }
    },

    setNameVariation() {
      let options = this.optionsItem.map((e) => e.values);
      let combinations = options.reduce((arrA, arrB) =>
        arrA.reduce((x, y) => x.concat(arrB.map((e) => [].concat(y, e))), [])
      );

      // TH: tên sp được thêm khi sp đã có phiên bản
      if (this.showTableVariations && this.Item.name != "") {
        this.Item.variations = this.Item.variations.map((e, index) => {
          console.log(Array.isArray(combinations[index]))
          return {
            ...e,
            name: `${
              this.Item.name + "-" +
              (Array.isArray(combinations[index])
                ? // TH: Có nhiều hơn 1 thuộc tính
                  combinations[index].join("-")
                : // TH: Chỉ có 1 thuộc tính
                  combinations[index])
            }`,
            nameOption: `${
              Array.isArray(combinations[index])
                ? // TH: Có nhiều hơn 1 thuộc tính
                  combinations[index].join("-")
                : // TH: Chỉ có 1 thuộc tính
                  combinations[index]
            }`,
          };
        });
      }
      // TH: tên sp bị xoáa khi sp đã có phiên bản
      else if (this.showTableVariations && this.Item.name == "") {
        let options = this.optionsItem.map((e) => e.values);
        const combinations = options.reduce((arrA, arrB) =>
          arrA.reduce((x, y) => x.concat(arrB.map((e) => [].concat(y, e))), [])
        );

        this.Item.variations = this.Item.variations.map((e, index) => {
          return {
            ...e,
            name: `${
              Array.isArray(combinations[index])
                ? // TH: Có nhiều hơn 1 thuộc tính
                  combinations[index].join("-")
                : // TH: Chỉ có 1 thuộc tính
                  combinations[index]
            }`,
            nameOption: `${
              Array.isArray(combinations[index])
                ? // TH: Có nhiều hơn 1 thuộc tính
                  combinations[index].join("-")
                : // TH: Chỉ có 1 thuộc tính
                  combinations[index]
            }`,
          };
        });
      }
    },

    selectOptionQuick(option) {
      if (option === "Xoá phiên bản") {
        this.selectedBox.map((select) => {
          const index = this.Item.variations.findIndex(
            (variation) => JSON.stringify(select) === JSON.stringify(variation)
          );

          this.Item.variations.splice(index, 1);

          if (this.Item.variations.length === 0) {
            this.showTableVariations = false;
            (this.selectedBox = []),
              (this.Item.options = []),
              (this.optionsItem = [
                {
                  name: "",
                  values: [""],
                },
              ]);
          }
        });
      }
    },

    inputPriceForRecords() {
      this.selectedBox.map((select) => {
        const index = this.Item.variations.findIndex(
          (variation) => JSON.stringify(select) ===JSON.stringify(variation)
        );

        this.Item.variations[index].prices.exportPrice = (this.exportPrice != '') ? this.exportPrice : 0;
        this.Item.variations[index].prices.importPrice = (this.importPrice != '') ? this.importPrice : 0;
      });

      this.$bvToast.toast(`Áp dụng giá nhập, giá bán thành công!`, {
        title: `Thông báo`,
        autoHideDelay: `3000`,
        variant: `success`,
        toaster: `b-toaster-top-center`,
        solid: true,
        appendToast: true,
      });

      this.selectedBox = [];
    },

    inputUpcForRecords(data) {
      data.map((element) => {
        const index = this.Item.variations.findIndex(
          (variation) => element.itemVariationId === variation.itemVariationId
        );

        this.$bvToast.toast(`Tạo mã vạch thành công!`, {
          title: `Thông báo`,
          autoHideDelay: `3000`,
          variant: `success`,
          toaster: `b-toaster-top-center`,
          solid: true,
          appendToast: true,
        });

        this.Item.variations[index].upc = element.upc
      });

      this.selectedBox = [];
    },

    handleVariation($event) {
      if ($event.length != 0) {
        this.optionsItem = $event;
        let options = this.optionsItem.map((e) => e.values);

        const combinations = options.reduce((arrA, arrB) =>
          arrA.reduce((x, y) => x.concat(arrB.map((e) => [].concat(y, e))), [])
        );

        // optionsVariations để format các trường trong option của mỗi phiên bản (for req call api)
        const optionsVariations = combinations.map((e) => {
          return Array.isArray(e)
            ? // TH: có nhiều hơn 1 thuộc tính
              e.map((item, index) => {
                return {
                  description: "",
                  name: this.optionsItem[index].name,
                  value: item,
                };
              })
            : // TH: có 1 thuộc tính
              [
                {
                  description: "",
                  name: this.optionsItem[0].name,
                  value: e,
                },
              ];
        });

        this.Item.variations = optionsVariations.map((e, index) => {
          const name = `${
            // TH: Có nhiều hơn 1 thuộc tính và tên sản phẩm khác rỗng
            Array.isArray(combinations[index]) && this.Item.name != ""
              ? this.Item.name + "-" + combinations[index].join("-")
              : // TH: Có nhiều hơn 1 thuộc tính và tên sản phẩm = rỗng
              Array.isArray(combinations[index]) && this.Item.name == ""
              ? combinations[index].join("-")
              : // TH: chỉ có 1 thuộc tính và tên sản phẩm khác rỗng
              !Array.isArray(combinations[index]) && this.Item.name != ""
              ? this.Item.name + "-" + combinations[index]
              : // TH: chỉ có 1 thuộc tính và tên sản phẩm = rỗng
                combinations[index]
          }`;
          return {
            variationId: "",
            itemVariationId: "",
            images: [],
            weightInGram:
              typeof this.Item.weightInGram === "string"
                ? parseInt(this.Item.weightInGram.replace(/,/g, ""))
                : this.Item.weightInGram,
            name: name,
            nameOption: Array.isArray(combinations[index])
              ? combinations[index].join("-") : combinations[index],
            options: e,
            prices: {
              name: name,
              exportPrice: this.checkNumReplaceComma(
                this.Item.priceItem.exportPrice
              ),
              importPrice: this.checkNumReplaceComma(
                this.Item.priceItem.importPrice
              ),
            },
            sku: "",
            upc: "",
            validate: {
              sku: "",
              upc: "",
            },
            unitMass: "gr",
            selected: false,
          };
        });
        this.listFields = this.fieldsVariation;
        this.showTableVariations = true;
      } else {
        this.showTableVariations = false;
        this.listFields = this.fieldVariationOnly;
        this.optionsItem = [
          {
            name: "",
            values: [""],
          },
        ];
      }
    },

    async getListCategorySub(value, type) {
      try {
        if (value != null) {
          this.Item.metaSearchable.category = value.name;
          this.categoryTmp = value
          this.Item.categorySub = "";
          this.Item.categoryId = "";
          this.dataCategorySub = [];
          if (value.text != "") {
            const params = {
              queryString: { parentId: { eq: value.id } },
              sort: "-id",
              lastItem: "",
              limit: 100,
            };
            const response = await CategoryService.getList(params);
            if (response.success) {
              this.dataCategorySub = response.data;
            }
          }

          if (type === 'add-new') {
            this.dataCategory.unshift(value)
          }
        }

        this.isPopupAddCategory = false
      } catch (error) {
        console.log(error);
      }
    },

    async checkSKU(value, index) {
      this.disabledSubmit = true;

      const result = await this.checkDublicate("sku", value);

      if (result) {
        this.disabledSubmit = true;
      } else {
        this.disabledSubmit = false;
      }

      if (index === undefined && result) {
        this.Item.validate.sku = "Mã SKU đã tồn tại";
      } else if (index != undefined && result) {
        this.Item.variations[index].validate.sku = "Mã SKU đã tồn tại";
      } else if (index === undefined && !result) {
        this.Item.validate.sku = "";
      } else if (index != undefined && !result) {
        this.Item.variations[index].validate.sku = "";
      }
    },

    async checkUPC(value, index) {
      this.disabledSubmit = true;

      const result = await this.checkDublicate("upc", value);

      if (result) {
        this.disabledSubmit = true;
      } else {
        this.disabledSubmit = false;
      }

      if (index === undefined && result) {
        this.Item.validate.upc = "Mã UPC đã tồn tại";
      } else if (index != undefined && result) {
        this.Item.variations[index].validate.upc = "Mã UPC đã tồn tại";
      } else if (index === undefined && !result) {
        this.Item.validate.upc = "";
      } else if (index != undefined && !result) {
        this.Item.variations[index].validate.upc = "";
      }
    },

    async checkDublicate(type, value) {
      try {
        const list =
          this.Item.variations.length > 0
            ? this.Item.variations.map((e) => e[type])
            : [];
        const result = this.dublicate(value, list);

        const params = {
          pagingAndSorting: { limit: 10, lastIndex: "", sortOrder: "DESC" },
          queryString:
            "{variations." + `${type}` + "}=='''" + `${value}` + "'''",
        };

        const response =
          value != "" ? await ProductService.getList(params) : { data: [] };

        if (response.data.length > 0 || result) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async createBarcode(index) {
      try {
        const result = await this.generateBarcode()
        if (!this.showTableVariations) {
          this.Item.upc = result
        } else {
          this.Item.variations[index].upc = result
        }
      } catch (error) {
        console.log(error);
      }
    },

    checkBarcode() {
      this.existedUpc  = this.selectedBox.filter((e) => (e.upc != ""))
      if (this.existedUpc.length != 0) {
        this.showPopup("check-barcode")
      } else {
        this.selectedBox.map((e,index) => {
          if (e.upc === "") {
            this.generateBarcode(index)
          }
        }) 
      }
    },

    async generateBarcode(index) {
      try {
        const resBarcode = await this.genBarcode(1)
        if (!this.showTableVariations) {
          this.Item.upc = resBarcode
        } else {
          this.Item.variations[index].upc = resBarcode
        }

        if (this.selectedBox.length > 0) {
          this.existedUpc.push(this.Item.variations[index])
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkConfigInventory(){
			const response = await SettingService.getDataMerchant();
			let enableInventory = false
			if(response.success){
				enableInventory = response.data.merchant.enableInventory
        this.useProductBatch = response.data.merchant.itemMgmtMethod?.expiry
        this.activeImeiByMerchant = response.data.merchant.itemMgmtMethod?.serialImei
			}
			if(!enableInventory){
				this.check = true
			}
		},
		async clickEnableInventory(){
			const params = {
				"coMerchantId": this.coMerchantId,
				"enableInventory": true
			}
			this.isUpload = true
			const response = await SettingService.enableInventory(params);
			if(response.success){
				this.popupEnableInventory = false
				this.popupEnableInventorySuccess = true
        this.check = false
				this.isUpload = false
			}
		},
		async clickHideInventorySuccess(){
			this.popupEnableInventorySuccess = false
		}
  },

  watch: {
    submit: {
      handler: async function () {
        this.loading = true;

        await this.$refs.observerItems.validate();

        if (this.disabledSubmit) {
          await this.sleep(500);
        }

        let el = document.querySelector(".is-invalid");

        if (el) {
          this.loading = false;
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el.focus();
          this.submit = false;
        } else {
          try {
            if (this.avatar.images.length > 0) {
              this.Item.images.push(this.avatar.images[0]);
            } else {
              this.Item.images.push("");
            }
            this.listImages.map((e) => this.Item.images.push(e));

            // call api create item
            const params = await this.handlerReqCreatItem(
              this.Item,
              this.optionsItem
            );
            const response = await ProductService.createItem(params);
            const permission =
              this.dataPermission &&
              this.dataPermission.includes("NSH_INV_ITEM_BALANCE");
            await this.sleep(700);
            this.loading = false;
            // check permission
            if (response.status === 200 && permission) {
              this.resItem = response.data
              this.idItem = response.data.item.id;

              this.$bvToast.toast(`Tạo sản phẩm thành công!`, {
                title: `Thông báo`,
                autoHideDelay: `3000`,
                variant: `success`,
                toaster: `b-toaster-top-center`,
                solid: true,
                appendToast: true,
              });
              this.showPopup("Dieu-chinh-ton-kho");
            } else {
              Swal.fire({
                icon: "success",
                title:
                  '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
                html: `<span style="color:#9093A4; font-size: 14px;" >Tạo sản phẩm thành công</span>`,
                confirmButtonText: "Xác nhận",
              }).then(() => {
                this.$router.push(`/items`);
              });
            }
          } catch (error) {
            console.log(error);
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>

.box-dashed {
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 100%;
  padding: 16px;
  height: 44px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  border: 1px dashed #9eb4fa;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: #fff;
  color: #3e69f6;
  cursor: pointer;

  svg,
  svg * {
    fill: #3e69f6;
  }
}
.table-responsive {
  width: 1500px;
}

.isSelling {
  display: flex;
  align-items: center;
  height: 100%;

  & > *:not(*:first-child) {
    margin-left: 10px;
  }
}

.field_check_box {
  display: flex;
  align-items: center;
  height: 100%;

  .check_box {
    display: flex;
    margin-right: 30px;
  }
}

::v-deep .upc-input {
  .__wrap {
    width: 224px;

    .__input {
      text-transform: uppercase;
    }
  }
}

.text-head-modal{
    color: #000;
    font-size: 15px;
    line-height: 20px;
    text-align: left;
    background: #f0f0f0;
    padding: 8px 10px;
  }
  .text-head-active{
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
  .text-des-active{
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
  .box-modals .btn {
    margin: 0 5px;
  }
  .line-active{
    border-top: 1px solid #ddd;
    padding-top: 12px;
  }
  .btn-closed{
    padding:10px 15px;
  }
  .arrTabs{
    display:inline-block;
    width: 100%;
  }
  .arrTabs li{
    display:inline-block;
    font-weight: bold;
    font-size: 20px;
    color: #a7acb1;
    cursor: pointer;
  }
  .arrTabs li.active{
    color: #23313E;
  }
  .card_wall{
    border-left: 2px solid #B9B9B9;
    margin: 0px 20px;
    display: inline-block;
    height: 22px;
    position: relative;
    top: 5px;
  }
</style>
